function toFiniteNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

function median(values) {
    const nums = (Array.isArray(values) ? values : [])
        .map(v => toFiniteNumber(v))
        .filter(v => v !== null)
        .sort((a, b) => a - b);
    if (!nums.length) return 0;
    const mid = Math.floor(nums.length / 2);
    return nums.length % 2 === 0
        ? (nums[mid - 1] + nums[mid]) / 2
        : nums[mid];
}

export function getMedianUsageStats(newsletterRefs) {
    const refs = Array.isArray(newsletterRefs) ? newsletterRefs : [];
    const clicks = refs
        .map(ref => toFiniteNumber(ref?.unique_clicks))
        .filter(v => v !== null && v >= 0);
    const impressions = refs
        .map((ref) => {
            const uniqueClicks = toFiniteNumber(ref?.unique_clicks);
            const ctr = toFiniteNumber(ref?.ctr);
            if (uniqueClicks === null || uniqueClicks < 0 || ctr === null || ctr <= 0) return null;
            // CTR is stored as decimal (e.g. 0.05 = 5%). Impressions are in thousands for CPM.
            return (uniqueClicks / ctr) / 1000;
        })
        .filter(v => v !== null && v > 0);

    return {
        medianUniqueClicks: median(clicks),
        medianImpressions: median(impressions),
    };
}

export function calculateEstimatedRevenuePerUsage({
    compModelType,
    compRate,
    avgPrice,
    compConversionRate,
    assumedConversionRate,
    medianUniqueClicks,
    medianImpressions
}) {
    const modelType = String(compModelType || 'cpa').trim().toLowerCase();
    const clicks = toFiniteNumber(medianUniqueClicks) ?? 0;
    const impressions = toFiniteNumber(medianImpressions) ?? 0;
    const rate = toFiniteNumber(compRate);
    const price = toFiniteNumber(avgPrice) ?? 0;
    const fallbackConversionRate = toFiniteNumber(assumedConversionRate) ?? 0.05;
    const conversionRate = (() => {
        const parsed = toFiniteNumber(compConversionRate);
        if (parsed !== null && parsed >= 0 && parsed <= 1) return parsed;
        return fallbackConversionRate;
    })();

    if (modelType === 'cpc') {
        if (rate === null || rate <= 0 || clicks <= 0) return 0;
        return clicks * rate;
    }

    if (modelType === 'cpm') {
        if (rate === null || rate <= 0 || impressions <= 0) return 0;
        return rate * impressions;
    }

    if (price <= 0 || clicks <= 0) return 0;

    const normalizedCommissionRate = rate === null
        ? 0.04
        : (rate > 1 ? (rate / 100) : rate);
    if (normalizedCommissionRate <= 0) return 0;

    return clicks * price * normalizedCommissionRate * conversionRate;
}
